import React, { Component } from "react";
import { help } from "../../utils/help";
import { staticTitles } from "../../utils/constants";
import "./Help.css";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import analyticss from "../../assets/onboarding/Analyticss.png";
import resources from "../../assets/onboarding/Resources.png";
import planning from "../../assets/onboarding/Planning.png";
import culture from "../../assets/onboarding/CultureApp.png";
import groups from "../../assets/onboarding/Groups.png";
import ContactUsModal from "./ContactUsModal";

class Help extends Component {
  constructor(props) {
    super(props);
    this.state = {
      contactUsModal: false,
      help,
      searchedTerm: "",
      helpLink:
        "https://docs.google.com/document/d/1d3k6noDVUgAfKnd27h3bJBhUNGK37Kip65HLMumbWwU/edit?usp=sharing",
    };
  }

  setContactUsModal = (val) => {
    this.setState({
      contactUsModal: val,
    });
  };

  componentDidMount() {
    console.log(this.props);
  }

  createMarkup = (input) => {
    // console.log(input)
    return { __html: `<div>${input}</div>` };
  };

  findWord = (string, regex) => {
    var match,
      indexes = {};

    regex = new RegExp(regex);

    while ((match = regex.exec(string))) {
      if (!indexes[match[0]]) indexes[match[0]] = [];
      indexes[match[0]].push(match.index);
    }

    return indexes;
  };

  handleSearchQueryChanged = ({ target }) => {
    let { value } = target;
    // console.log(value)
    // this.state.officeMates
    let { help } = this.state;

    let idx = 0,
      phrase = [],
      content,
      word;
    content = help;
    console.log(target, value, help.length, content.length);

    // console.log

    if (value.length === 0) {
      phrase = content;
    } else {
      idx = content.search(value);
      if (idx > 100) {
        word = content.slice(idx - 80, idx + 180);
      } else if (idx > -1 && idx <= 100) {
        word = content.slice(0, idx + 100);
      } else if (idx < 0) {
        word = "<h4>There is no term matching your phrase.</h4>";
      }
      // let val = this.findWord(help, value)
      // console.log(val)
      phrase.push(word);
    }

    //    console.log('phr---', phrase)

    this.setState({
      searchedTerm: value,
      searchedPhrase: `<div class="searchResult">${phrase}</div>`,
    });
  };

  renderContent = () => {
    let { searchedPhrase, help, searchedTerm } = this.state;
    if (searchedTerm !== "") {
      return (
        <div dangerouslySetInnerHTML={this.createMarkup(searchedPhrase)} />
      );
    } else {
      return <div dangerouslySetInnerHTML={this.createMarkup(help)} />;
    }
  };

  render() {
    let { searchedTerm, contactUsModal } = this.state;
    return (
      <div className="helpContent">
        {contactUsModal && (
          <ContactUsModal
            isOpen={contactUsModal}
            toggle={() => {
              this.setContactUsModal(false);
            }}
          />
        )}
        <h1>
          How can we help you{" "}
          {this.props.user.firstName ? this.props.user.firstName : ""} ?
        </h1>

        <div className="helpContainer">
          {/* <p className="mt40">
            For the OurOffice Handbook,{" "}
            <a
              className="contact-us"
              target="_blank"
              href={this.state.helpLink}
            >
              click here{" "}
            </a>
            .
          </p> */}
          <p className="mt40">
            For the OurOffice Product Guides, click below .
          </p>

          <div className="mt40">
            <div className="d-flex">
              <div className="help-img-container">
                <a
                  href="https://docs.google.com/presentation/d/14bqpzeMlcIIHGlWNGXF5WXVH0Q4rhjvsvio2ttDspbw/edit#slide=id.g28a244033e9_0_2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  <img src={planning} />
                </a>
              </div>
              <div className="help-img-container">
                <a
                  href="https://docs.google.com/presentation/d/1RsjuNMsNcXQcwgxO_E6SFRBx1AAUQQUByBqYXgX1fUA/edit#slide=id.g28a244033e9_0_2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={analyticss} />
                </a>
              </div>
              <div className="help-img-container">
                <a
                  href="https://docs.google.com/presentation/d/1LyyVvvnWvBFvBoOo1TsX9QM4SD5bSI4Fw2W-VMZFHe4/edit#slide=id.g28a244033e9_0_2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  <img src={culture} />
                </a>
              </div>
              <div className="help-img-container">
                <a
                  href="https://docs.google.com/presentation/d/1uE3baveID5EM4LqHdDW6UIn_0wyQah2cFmh-CIMGocw/edit#slide=id.g28a244033e9_0_2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  <img src={groups} />
                </a>
              </div>
              <div className="help-img-container">
                <a
                  href="https://docs.google.com/presentation/d/1dAuzElbhedNJlsiM9cfmH4pKBoj1M0-499gfvX68vPw/edit#slide=id.g28a244033e9_0_2"
                  target="_blank"
                  rel="noopener noreferrer"
                >
                  {" "}
                  <img src={resources} />
                </a>
              </div>
            </div>
          </div>

          <div className="mt-5">
            <p>For other OurOffice helpful links, click below.</p>
          </div>
          <div className="mt-2">
            <p>
              How to Share Posts and Actions to MS Teams (
              <a
                href="https://docs.google.com/presentation/d/1kQ2bjdlTCdjev9HdEQG32wDQi6hjx3qonMKmnUGbNtc/edit#slide=id.g28a244033e9_0_2"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
              ){" "}
            </p>
          </div>
          <div className="mt-2">
            <p>
              How to Add an Action (
              <a
                href="https://docs.google.com/presentation/d/1r552nbweTElWCflgXg2jyAUWoUW5dAKCu9wxdGXfPbU/edit#slide=id.g28a244033e9_0_2"
                target="_blank"
                rel="noopener noreferrer"
              >
                here
              </a>
              ){" "}
            </p>
          </div>

          {/* <div className="helpVidContent mt40">

                <div className="col-sm-6 inlineBlock paddingLeft0">
                    <p>For a tour of {staticTitles.stories}, click below.  </p>
                    <iframe src="https://www.youtube.com/embed/bhXR3IJNSmo?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="true"></iframe>                   
                </div>


                <div className="col-sm-6 inlineBlock paddingRight0">
                    <p>For a tour of Analytics, click below.  </p>
                    <iframe src="https://www.youtube.com/embed/1YYuClnmKPE?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="true"></iframe>
                </div>



                <div className="col-sm-6 inlineBlock paddingLeft0">
                    <p>For a tour of Planning, click below.  </p>
                    <iframe src="https://www.youtube.com/embed/UONcLJ8OU4A?rel=0" frameborder="0" allow="accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture" allowfullscreen="true"></iframe>                   
                </div>
            </div> */}

          <p>
            <a
              className="contact-us cursor-pointer"
              onClick={() => {
                this.setContactUsModal(true);
              }}
            >
              Contact Us
            </a>
          </p>
        </div>

        {/* <embed src='https://prod-oo-app-attachment.s3.us-east-2.amazonaws.com/Attachment/OurOffice+Handbook+(June+2019).pdf#zoom=120' width="100%" height="600px"/> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => {
  return {
    user: state.user.profile,
  };
};

export default connect(mapStateToProps)(withRouter(Help));
// export default Help
